import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { CaretLeft, CaretRight } from "phosphor-react";

import genreOfmovieFetch from "../../redux/movieOfgenre/movieOfgenreAction";
import genreFetch from "../../redux/genre/genreAction";

// Components
import Search from "../../components/search/index";
import CardShimmer from "../../components/search/card_shimmer";
import Breadcrumb from "../../components/breadcrumb/index";

const Index = () => {
  const [pageCount, setPageCount] = useState(1);
  const [genre, setGenre] = useState(1);

  const dispatch = useDispatch();
  const movieOfgenreState = useSelector((state) => state.movieOfgenreState);
  const genreState = useSelector((state) => state.genreState);

  useEffect(() => {
    dispatch(genreFetch());
    dispatch(genreOfmovieFetch({ genre_id: genre, page: pageCount }));
  }, [dispatch, genre, pageCount]);

  const NextClick = () => {
    setPageCount(pageCount + 1);
  };
  const PrevClick = () => {
    if (pageCount > 1) setPageCount(pageCount - 1);
  };

  const SelectChangeHandler = (e) => {
    setGenre(e.target.value);
    setPageCount(1);
    dispatch(genreOfmovieFetch({ genre_id: genre, page: 1 }));
  };
  let ArrS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  return (
    <>
      <div className="p-4 lg:px-24">
        <Breadcrumb />
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
          <div className="lg:col-span-10">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center space-x-2 text-3xl font-bold">
                <h1>Resualt</h1>
                {movieOfgenreState?.movieOfgenre?.metadata?.total_count ? (
                  <h1>
                    {movieOfgenreState?.movieOfgenre?.metadata?.total_count}
                  </h1>
                ) : (
                  <div className="animate-pulse bg-slate-200 h-6 w-16 rounded-lg"></div>
                )}
              </div>
              <div className="flex mt-0 space-x-2 justify-center z-20 rounded-xl">
                <button
                  disabled={
                    movieOfgenreState?.movieOfgenre?.metadata?.current_page ===
                      "1" && true
                  }
                  onClick={PrevClick}
                  className={`${
                    movieOfgenreState?.movieOfgenre?.metadata?.current_page ===
                      "1" && "disabled:opacity-50"
                  } flex items-center justify-center p-3 bg-white text-slate-900 border border-slate-300 rounded-xl transition-all duration-300 ease-in-out hover:bg-slate-100`}
                >
                  <CaretLeft size={24} />
                </button>
                <p className="p-3">{pageCount}</p>
                <button
                  onClick={NextClick}
                  disabled={
                    movieOfgenreState?.movieOfgenre?.metadata?.page_count <=
                      1 && true
                  }
                  className={`${
                    movieOfgenreState?.movieOfgenre?.metadata?.page_count <=
                      1 && "disabled:opacity-50"
                  } flex items-center justify-center p-3 bg-slate-900 text-white rounded-xl transition-all duration-300 ease-in-out hover:bg-slate-800`}
                >
                  <CaretRight size={24} />
                </button>
              </div>
            </div>

            {movieOfgenreState.loading ? (
              <div className="grid grid-cols-2 md:!grid-cols-4 lg:!grid-cols-4 gap-4">
                {ArrS.map((index) => (
                  <CardShimmer key={index} />
                ))}
              </div>
            ) : movieOfgenreState.error ? (
              <div className="grid grid-cols-2 md:!grid-cols-4 lg:!grid-cols-4 gap-4">
                {ArrS.map((index) => (
                  <CardShimmer key={index} />
                ))}
              </div>
            ) : movieOfgenreState?.movieOfgenre?.data &&
              movieOfgenreState?.movieOfgenre?.data.length > 0 ? (
              <div className="grid grid-cols-2 md:!grid-cols-4 lg:!grid-cols-4 gap-4">
                {movieOfgenreState?.movieOfgenre?.data?.map((movie) => (
                  <Search key={movie.id} data={movie} />
                ))}
              </div>
            ) : (
              <div className="flex items-center justify-center bg-slate-100 w-full h-96 rounded-xl">
                <h1>Not Found</h1>
              </div>
            )}
          </div>
          <div className="-order-1 lg:-order-1 lg:col-span-2 relative">
            <div className="bg-slate-50 rounded-xl p-4 border space-y-3">
              <label className="mb-4" htmlFor="gnres">
                Choose a gnres:
              </label>
              <select
                onChange={SelectChangeHandler}
                className="bg-white rounded-xl px-4 py-2 w-full border"
                name="gnres"
                id="gnres"
              >
                <option value={1}>Select</option>
                {genreState.loading
                  ? "Loading"
                  : genreState.error
                  ? genreState.error
                  : genreState?.genres.map((item) => (
                      <option value={item.id} key={item.id}>
                        {item.name}
                      </option>
                    ))}
              </select>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;
